import { ContentfulDocumentSlug, useDocument } from 'api/contentful/getDocument'
import { ContentfulContent } from 'components/content/contentfulContent/ContentfulContent'
import { BlockSpinner } from 'components/spinner/Spinner'
import { SLoadingWrapper } from './ContentfulDocument.styled'

export function ContentfulDocument(props: { slug: ContentfulDocumentSlug }) {
  const { data } = useDocument(props.slug)

  if (!data)
    return (
      <SLoadingWrapper>
        <BlockSpinner />
      </SLoadingWrapper>
    )

  return <ContentfulContent data={data} />
}
